type Listener = (count: number) => void;

class LoadingBus {
  private listeners: Set<Listener> = new Set();
  private count = 0;

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    listener(this.count);
    return () => this.listeners.delete(listener);
  }

  increment() {
    this.count += 1;
    this.emit();
  }

  decrement() {
    this.count = Math.max(0, this.count - 1);
    this.emit();
  }

  private emit() {
    this.listeners.forEach((l) => {
      try { l(this.count); } catch {}
    });
  }
}

export const loadingBus = new LoadingBus();